import * as ActionTypes from "../actions/index";
import moment from 'moment';
import _ from 'lodash';
import {errorParser} from "../helpers/functions";
import { POLICY_STATUS_MN_DRAFT } from "../helpers/constants";
import {
	arrayUnique,
	createObjectWithPropertyTriggeredQuestionsAndValuesQuestionsThatTriggerThem,
	findQuestionByMachineName, findQuestionsThatTriggersQuestions, findQuestionsTriggeredByQuestions,
	flattenQuestions, getAnswersOfApplication, getAnswersOfMedicalExpertFeesQuestion,
	getAnswersOFOpponentQuestionGroup, getFirstLevelQuestionTree, getTriggeredQuestionFromQuestionsMayBeTriggered, questionsTriggeredByQuestions
} from "../helpers/questions/functions";
import { useState } from "react";

const defaultState = {
	questions: [],
	application: {},
	caseTypes: [],
	subCaseTypes: [],
	solicitorFileReference: '',
	clientName: '',
	postCode: '',
	selectedCaseType: '',
	selectedSubCaseType: '',
	showForm: false,
	formData: {},
	featuredQuestions: [],
	msg: '',
	badMsg: '',
	duplicate: false,
	confirmation: '',
	files: [],
	extraOpponents: [],
	attachments: [],
	attachmentsForDisplay: [],
	posting: false,
	patchedApplication: {},
	fetching: false,
	modalCalendar: '',
	triggeredQuestionsToDisplay:[],
	selectedApplication: {},
	fetchingSelectedApp: false,
	medicalExpertFees: [],
	workSourceId: '',
	workSourceName: '',
	dateOfBirth: '',
	address: '',
	solicitorGroupWorkSources: [],
	opponentQuestions: [],
	medExpertFees: [], //implementing again medicalExpertFees
	submitted: false,
	referralExists: true,
	failedToGetApplicationAttachments: '',
    fetchingAllApplicationAttachments: false,
	abandonedReason: '',
	rejectedReason: '',
    referredReason: '',
	getApplicationFormErrorMessage: '',
	questionsTriggeredByQuestions:[],
	triggeredQuestions:{},
	// === editable question answers ===
	questionAnswerModalOpen: false,
	applicationUpdateAction: null,
    questionAnswerForEdit: {},
    questionAnswer: '',
	updatingQuestionAnswer: false,
	deleteModalOpen:false,
    updatingQuestionAnswerFail: '',
	questionAnswerOpponent: {},
	questionAnswerMedicalExpertFees: [],
	updatingApplicationAfterUpdatingApplicationAnswer: false,
	// === ===

	//arag user as solicitor
	username:'',
	userId:'',
	solicitorFirmIdSelected:''
	// === ===
};

export default (state = defaultState, action) => {
	let msg = '';
	switch (action.type) {
		case ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE:
			return {
				...state,
				updatingApplicationAfterUpdatingApplicationAnswer: true
			};
		case ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_FAILED:
			return {
				...state,
				updatingApplicationAfterUpdatingApplicationAnswer: false
			};

		case ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT:
			return {
				...state,
                updatingQuestionAnswer: true,
                updatingQuestionAnswerFail: defaultState.updatingQuestionAnswerFail
			};
		case ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_SUCCESS:
			return {
				...state,
				updatingQuestionAnswer: false,
				applicationUpdateAction: defaultState.applicationUpdateAction,
				questionAnswerForEdit: defaultState.questionAnswerForEdit,
				questionAnswer: defaultState.questionAnswer,
				updatingQuestionAnswerFail: defaultState.updatingQuestionAnswerFail,
				questionAnswerOpponent: defaultState.questionAnswerOpponent,
				questionAnswerMedicalExpertFees: defaultState.questionAnswerMedicalExpertFees
			};
		case ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_FAIL:
			let updatingQuestionAnswerFailMessage = '';
			try {
                updatingQuestionAnswerFailMessage = errorParser(action.payload.response);
				if(!updatingQuestionAnswerFailMessage){
					updatingQuestionAnswerFailMessage = "Failed to update.";
				}
            } catch (e) {
                updatingQuestionAnswerFailMessage = 'Failed to update.'
            }
			return {
				...state,
                updatingQuestionAnswer: false,
                updatingQuestionAnswerFail: updatingQuestionAnswerFailMessage
            };
		case ActionTypes.OPEN_EDIT_QUESTION_ANSWER_MODAL:
			return {
				...state,
				questionAnswerModalOpen: true,
				applicationUpdateAction: action.payload.applicationUpdateAction,
                questionAnswerForEdit: action.payload.questionAnswerForEdit,
                questionAnswer: action.payload.questionAnswer,
                questionAnswerOpponent: action.payload.questionAnswerOpponent,
                questionAnswerMedicalExpertFees: action.payload.questionAnswerMedicalExpertFees
			};
		case ActionTypes.CLOSE_EDIT_QUESTION_ANSWER_MODAL:
			return {
				...state,
                questionAnswerModalOpen: false,
				applicationUpdateAction: defaultState.applicationUpdateAction,
                questionAnswerForEdit: defaultState.questionAnswerForEdit,
                questionAnswer: defaultState.questionAnswer,
                updatingQuestionAnswerFail: defaultState.updatingQuestionAnswerFail,
                questionAnswerOpponent: defaultState.questionAnswerOpponent,
                questionAnswerMedicalExpertFees: defaultState.questionAnswerMedicalExpertFees
			};
		case ActionTypes.RECEIVE_DELETE_DOCUMENT_RESPONSE:
			if (state.attachmentsForDisplay.length > 0) {
				let selectedAppAttachments = [...state.attachmentsForDisplay];
				let newSelectedAttachmentsForDisplay = [...state.attachmentsForDisplay];
				for (let i = 0; i < selectedAppAttachments.length; i++) {
					if (action.payload.attachmentId === selectedAppAttachments[i].id) {
						selectedAppAttachments.splice(i, 1);
						newSelectedAttachmentsForDisplay = selectedAppAttachments
						break;
					}
				}
				return {
					...state,
					attachmentsForDisplay: newSelectedAttachmentsForDisplay
				}
			}
			return {
				...state,
			};
		case ActionTypes.REMOVE_NEW_APPLICATION_ATTACHMENT:
			if (state.attachmentsForDisplay.length > 0) {
				let selectedAppAttachments = [...state.attachmentsForDisplay];
				let newSelectedAttachmentsForDisplay;
				for (let i = 0; i < selectedAppAttachments.length; i++) {
					if (action.payload === selectedAppAttachments[i].id) {
						selectedAppAttachments.splice(i, 1);
						newSelectedAttachmentsForDisplay = selectedAppAttachments
						break;
					}
				}
				return {
					...state,
					attachmentsForDisplay: newSelectedAttachmentsForDisplay
				}
			}
			return {
				...state,
			};
		case ActionTypes.RECEIVE_DELETE_DRAFTED_APPLICATION_RESPONSE:
			return {
				...state,
				solicitorFileReference: '',
				clientName: '',
				postCode: '',
				selectedCaseType: '',
				selectedSubCaseType: '',
				showForm: false,
				formData: {},
				featuredQuestions: [],
				questions: [],
				application: {},
				confirmation: '',
				msg: '',
				badMsg: '',
				extraOpponents: [],
				attachments: [],
				posting: false,
				patchedApplication: {},
				duplicate: false,
				medicalExpertFees: []
			};
		case ActionTypes.GET_APPLICATION_POLICY_AFTER_AD_CREATE:
			return {
				...state,
				fetching: true
			};
		case ActionTypes.REQUEST_GET_APPLICATION:
			return {
				...state,
				fetching: true,
                getApplicationFromErrorMessage: defaultState.getApplicationFromErrorMessage
			};
		case ActionTypes.REQUEST_GET_SELECTED_APPLICATION:
			return {
				...state,
				fetchingSelectedApp: true
			};
		case ActionTypes.RECEIVE_BAD_REQUEST_GET_SELECTED_APPLICATION:
			return {
				...state,
				fetchingSelectedApp: false
			};
		case ActionTypes.RECEIVE_SUB_CASE_TYPES_SELECTED_APP:
			return {
				...state,
				subCaseTypes: action.payload.subCaseTypes
			};
		case ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE:
			return {
				...state,
				fetchingSelectedApp: true
			};
		case ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_FAILED:
			return {
				...state,
				fetchingSelectedApp: false
			};
		case ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_SUCCESS:
		case ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_SUCCESS:
		case ActionTypes.RECEIVE_GET_SELECTED_APPLICATION:
			if(!action.payload) return defaultState;
			let formDataApp = {};
			let questionsApp = [];
			let patchedApplicationApp = {};
			let attachmentsApp = [];
			let extraOpp = [];
			let oppQuestions = [];
			let allFlattenedQuestions = [];
			let selectedAppMedicalExpertFees = [];
			let questionsTriggeredByQuestionsArray = [];
			let triggeredQuestionsArray = [];

			if (action.payload !== null) {
				if (action.payload.hasOwnProperty('questionsDtos')) {
					questionsApp = action.payload.questionsDtos;
					allFlattenedQuestions = _.uniqBy(flattenQuestions(questionsApp), 'id');
					questionsTriggeredByQuestionsArray =findQuestionsTriggeredByQuestions(allFlattenedQuestions);
					triggeredQuestionsArray = createObjectWithPropertyTriggeredQuestionsAndValuesQuestionsThatTriggerThem(questionsTriggeredByQuestionsArray);
				}
				if (action.payload.hasOwnProperty('attachments')) {
					attachmentsApp = action.payload.attachments;
				}

				// check if form contains medical expert fees question
				const foundFeesQ = findQuestionByMachineName("EstimateForMedicalExpertFees", allFlattenedQuestions);
				if(
					foundFeesQ
					&& action.payload.applicationMedicalExpertFees
					&& action.payload.applicationMedicalExpertFees.length > 0
				){
					selectedAppMedicalExpertFees = action.payload.applicationMedicalExpertFees
						.map( fee => (
							getAnswersOfMedicalExpertFeesQuestion(fee.id, action.payload)
						))
				}

				// check if form contains opponent question
				const foundOppQ = findQuestionByMachineName("OpponentName", allFlattenedQuestions);
				if(
					foundOppQ
					&& action.payload.applicationOpponents
					&& action.payload.applicationOpponents.length > 0
				){
					extraOpp = action.payload.applicationOpponents.map(appOpp => (
						getAnswersOFOpponentQuestionGroup(appOpp.id, action.payload)
					));
					oppQuestions = getFirstLevelQuestionTree(foundOppQ);
				}

				// construct the application form initial values and then populate them based on existing
				// application answers
				formDataApp = _
					.chain(allFlattenedQuestions)
					.keyBy(q => q.id)
					.mapValues( datum => state.formData[datum.id] ? state.formData[datum.id] : "")
					.value();
				formDataApp = getAnswersOfApplication(action.payload);

				if (action.payload.policyStatusMachineName === POLICY_STATUS_MN_DRAFT) {
					patchedApplicationApp = action.payload;
				}
				//initial check for triggered conditional questions 
				var keysQuestionIds = _.keys(triggeredQuestionsArray);
				var parsedQuestionsIds = keysQuestionIds.map(k => parseInt(k));
				var triggeredQuestionsCheck = getTriggeredQuestionFromQuestionsMayBeTriggered(formDataApp, questionsTriggeredByQuestionsArray.filter(x => parsedQuestionsIds.includes(x.id)), allFlattenedQuestions);
				var conditionalQuestionsToDisplay = [];
				if (triggeredQuestionsCheck.length > 0) {
					conditionalQuestionsToDisplay = arrayUnique(state.triggeredQuestionsToDisplay.concat(triggeredQuestionsCheck));
				}
			}
			return {
				...state,
				fetching: false,
				selectedApplication: action.payload,
				solicitorFileReference: action.payload.solicitorReference,
				clientName: action.payload.clientName,
				postCode: action.payload.postCode,
				selectedCaseType: action.payload.hasOwnProperty('caseTypeId') ? action.payload.caseTypeId.toString() : '',
				selectedSubCaseType: action.payload.subCaseTypeId !== null ? (action.payload.hasOwnProperty('subCaseTypeId') ? action.payload.subCaseTypeId.toString() : '') : '',
				formData: formDataApp,
				questions: allFlattenedQuestions,
				application: action.payload,
				patchedApplication: patchedApplicationApp,
				fetchingSelectedApp: false,
				attachmentsForDisplay: attachmentsApp,
				extraOpponents: extraOpp,
				medicalExpertFees: action.payload.applicationMedicalExpertFees,
				medExpertFees: selectedAppMedicalExpertFees,
				address: action.payload.address ? action.payload.address : '',
				workSourceId: action.payload.workSourceId ? action.payload.workSourceId : '',
                workSourceName: action.payload.workSourceName ? action.payload.workSourceName : '',
				dateOfBirth: action.payload.dateOfBirth !==null ? moment(action.payload.dateOfBirth).format("DD/MM/YYYY") : '',
				opponentQuestions: oppQuestions,
				questionsTriggeredByQuestions: questionsTriggeredByQuestionsArray,
				triggeredQuestions: triggeredQuestionsArray,
				triggeredQuestionsToDisplay:conditionalQuestionsToDisplay.length > 0 ?conditionalQuestionsToDisplay:state.triggeredQuestionsToDisplay,
				//======= UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_SUCCESS action
				deleteModalOpen:false,
                updatingQuestionAnswer: false,
                questionAnswerModalOpen: false,
                questionAnswerForEdit: defaultState.questionAnswerForEdit,
                questionAnswer: defaultState.questionAnswer,
                questionAnswerOpponent: defaultState.questionAnswerOpponent,
                questionAnswerMedicalExpertFees: defaultState.questionAnswerMedicalExpertFees,
				updatingApplicationAfterUpdatingApplicationAnswer: false,
				//=======
			};
		case ActionTypes.REQUEST_GET_ALL_APPLICATION_ATTACHMENTS:
			return {
				...state,
				fetchingAllApplicationAttachments: true
			};
		case ActionTypes.RECEIVE_ALL_APPLICATION_ATTACHMENTS:
			return {
				...state,
				attachmentsForDisplay: action.payload,
                fetchingAllApplicationAttachments: false
			};
		case ActionTypes.FAILED_TO_GET_ALL_APPLICATION_ATTACHMENTS:
			let failedToGetApplicationAttachmentsMsg = '';
			try {
                failedToGetApplicationAttachmentsMsg = action.payload.response.body.message
            } catch (e) {
                failedToGetApplicationAttachmentsMsg = 'Failed to receive application attachments. Please try again later.'
            }
			return {
				...state,
                fetchingAllApplicationAttachments: false,
                failedToGetApplicationAttachments: failedToGetApplicationAttachmentsMsg
			};
		case ActionTypes.RECEIVE_POST_OVERVIEW_POLICY_FORM:
			if (action.payload.hasOwnProperty('attachment'))
				return {
					...state,
					attachmentsForDisplay: action.payload.attachment ? [action.payload.attachment, ...state.attachmentsForDisplay] : state.attachmentsForDisplay
				};
			return {
				...state
			};
		case ActionTypes.RECEIVE_GET_APPLICATION_READ_BY_ARAG:
			if (state.selectedApplication !== null) {
				state.selectedApplication.readByArag = action.payload;
			}
			return {
				...state,
				selectedApplication: state.selectedApplication
			};
		case ActionTypes.RECEIVE_POST_UPDATE_POLICY_FORM:
			if(action.payload !== null){
				if (action.payload.hasOwnProperty('attatchment')) {
					if (action.payload.attatchment !== null)
						return {
							...state,
							attachmentsForDisplay: [action.payload.attatchment, ...state.attachmentsForDisplay]
						};
					else return {
						...state
					}
				}
			}
			return {
				...state
			};
			case ActionTypes.GET_POLICY_AS_SOLICITOR:
				return {
					...state,
					fetching:true
				}
		case ActionTypes.RECEIVE_GET_APPLICATION:
			let formData = {};
			let questions = [];
			let application = {};
			let extraDefaultOpp = [...state.extraOpponents];
			let opponentQuestions = [];
			let flattenedQuestions = [];
			let questionsTriggeredByQuestions = [];
			let triggeredQuestions = {};
			let medExpertFees = [...state.medExpertFees];
			if (action.payload !== null) {
				application = action.payload;
				questions = action.payload.questionsDtos;
				flattenedQuestions = _.uniqBy(flattenQuestions(questions), 'id');
				questionsTriggeredByQuestions =findQuestionsTriggeredByQuestions(flattenedQuestions);
				triggeredQuestions = createObjectWithPropertyTriggeredQuestionsAndValuesQuestionsThatTriggerThem(questionsTriggeredByQuestions);

				// check if form contains medical expert fees question
				const foundFeesQuestion = findQuestionByMachineName("EstimateForMedicalExpertFees", flattenedQuestions);
				if(foundFeesQuestion){
					if(state.medExpertFees.length > 0){
						medExpertFees = [...state.medExpertFees];
					} else {
						medExpertFees.push({
							name: '',
							natureOfExpert: '',
							whySpecificExpert: '',
							breachCausationCpId: '',
							partialEstimatedCost: '',
							attendanceEstimatedCost: '',
						})
					}
				}

				// check if form contains opponent question
				const foundOppQuestion = findQuestionByMachineName("OpponentName", flattenedQuestions);
				if(foundOppQuestion){
					if(state.extraOpponents.length > 0){
						extraDefaultOpp = [...state.extraOpponents];
					} else {
						extraDefaultOpp = [{
							name: '',
							prospectsOptionId: '',
							insuredOptionId: '',
							satisfiedOptionId: ''
						}];
					}
					opponentQuestions = getFirstLevelQuestionTree(foundOppQuestion);
				}

				// construct the application form initial values
				formData = _
					.chain(questions)
					.keyBy(q => q.id)
					.mapValues( datum => state.formData[datum.id] ? state.formData[datum.id] : "")
					.value();
			}

			return {
				...state,
				application: application,
				formData: formData,
				questions: flattenedQuestions,
				fetching: false,
				extraOpponents: extraDefaultOpp,
				medicalExpertFees: [], //TODO: check
				opponentQuestions: opponentQuestions,
				medExpertFees: medExpertFees,
                referralExists: action.payload === null?false:state.referralExists,
				questionsTriggeredByQuestions,
				triggeredQuestions
			};
		case ActionTypes.RECEIVE_SOLICITOR_GROUP_CASE_TYPES:
            let subCases = [];
            _.forEach(action.payload, (item) => {
                subCases = [...subCases, ...item.subCaseTypes.map(item => {return item} )]
            });
			return {
				...state,
                caseTypes: action.payload,
                subCaseTypes: subCases
			};
		case ActionTypes.RECEIVE_GET_CASE_TYPES:
			return {
				...state,
				caseTypes: action.payload
			};
		case ActionTypes.RECEIVE_SUB_CASE_TYPES:
			return {
				...state,
				subCaseTypes: action.payload
			};
		case ActionTypes.ATTACHMENTS_CHANGE: {
			return {
				...state,
				attachments: [...state.attachments, action.payload]
			}
		}
		case ActionTypes.ATTACHMENT_REMOVE:
			let newAttachments = [...state.attachments];
			if (action.payload > -1) {
				newAttachments.splice(action.payload, 1);
			}
			return {
				...state,
				attachments: newAttachments
			};
		case ActionTypes.CHANGE_NEW_APPLICATION_FIELD:
			if ((action.payload.key === 'selectedCaseType'))
				return {
					...state,
					[action.payload.key]: action.payload.value,
					selectedSubCaseType: '',
					showForm: false,
					msg: '',
					badMsg: '',
					referralExists: true
				};
			else if ((action.payload.key === 'selectedSubCaseType')) {
				return {
					...state,
					[action.payload.key]: action.payload.value,
					showForm: false,
					msg: '',
					badMsg: '',
                    referralExists: true
				};
			}
			else if (action.payload.key === 'msg' || (action.payload.key === 'badMsg'))
				return {
					...state,
					[action.payload.key]: action.payload.value
				};
			return {
				...state,
				[action.payload.key]: action.payload.value,
				msg: '',
				badMsg: ''
			};
		case ActionTypes.CHANGE_NEW_APPLICATION_FORM_DATA:
			// Create a copy of the state to avoid mutation
			let localState = { ...state };
					
			// Extract ids from the array of objects
			let triggeredQuestionIdsToDisplay = localState.triggeredQuestionsToDisplay.map(item => item.id);
			let triggeredQuestionIds = Object.keys(localState.triggeredQuestions).map(item => parseInt(item));
			
			// Filter the object of arrays
			let triggeredQuestionIdsToRemove = triggeredQuestionIds.filter(item => !triggeredQuestionIdsToDisplay.includes(item));
		
			triggeredQuestionIdsToRemove.forEach(key => {
				delete localState.formData[key];
			});

			if (action.payload.key === 'dateOfBirth') {
				return {
					...localState,
					[action.payload.key]: action.payload.value
				};
			} else if (action.payload.key === 'workSourceId') {
				return {
					...localState,
					[action.payload.key]: action.payload.value
				};
			} 
			else if (action.payload.key === 'userId') {
				return {
					...localState,
					[action.payload.key]: action.payload.value,
					selectedCaseType:'',
					selectedSubCaseType: '',
					showForm: false,
					application: {},
					formData: {},
					questions: [],
					fetching: false,
					extraOpponents:  [],
					caseTypes:[],
					subCases:[],
					medicalExpertFees: [], //TODO: check
					opponentQuestions:  [],
					medExpertFees:  [],
                	referralExists:true,
					questionsTriggeredByQuestions:[],
					triggeredQuestions:{},
					getApplicationFromErrorMessage:''
					
				};
			}
				else if (action.payload.key === 'solicitorFirmIdSelected') {
				return {
					...localState,
					[action.payload.key]: action.payload.value,
					userId:'',
					selectedCaseType:'',
					selectedSubCaseType: '',
					showForm: false,
					application: {},
					formData: {},
					questions: [],
					fetching: false,
					extraOpponents:  [],
					medicalExpertFees: [], //TODO: check
					opponentQuestions:  [],
					medExpertFees:  [],
                	referralExists:true,
					questionsTriggeredByQuestions:[],
					triggeredQuestions:{},
					getApplicationFromErrorMessage:''
				};
				
			}else {
				return {
					...localState,
					formData: {...localState.formData, [action.payload.key]: action.payload.value}
				};
			}
		case ActionTypes.RECEIVE_POST_NEW_APPLICATION:
			if (action.payload.draft === true) {
				msg = 'Application was saved successfully.';
				return {
					...state,
					msg: msg,
					badMsg: '',
					posting: false,
					patchedApplication: action.payload,
                    attachments: [],
					attachmentsForDisplay: [...action.payload.attachments, ...state.attachmentsForDisplay]
				};
			}
			else {
				msg = 'Application was submitted successfully.'
			}
			return {
				...state,
				solicitorFileReference: '',
				clientName: '',
				postCode: '',
				selectedCaseType: '',
				selectedSubCaseType: '',
				showForm: false,
				formData: {},
				featuredQuestions: [],
				questions: [],
				application: {},
				confirmation: '',
				msg: msg,
				badMsg: '',
				extraOpponents: [],
				attachments: [],
				posting: false,
				patchedApplication: {},
				duplicate: false,
				medicalExpertFees: [],
				submitted: true,
				selectedApplication: action.payload,
			};
		case ActionTypes.REQUEST_POST_NEW_APPLICATION:
			return {
				...state,
				posting: true,
                badMsg: '',
				msg: ''
			};
			case ActionTypes.REQUEST_POST_NEW_APPLICATION_AS_SOLICITOR:
				return {
					...state,
				posting: true,
				badMsg: '',
				msg: ''
				};
		case ActionTypes.RECEIVE_BAD_REQUEST_POST_NEW_APP:
			let postAppErrorMsg = '';
			try {
                postAppErrorMsg = action.payload.response.body.message;
            } catch (e) {
                postAppErrorMsg = 'Failed to create application.'
            }
			if (postAppErrorMsg === 'The application seems to be a duplicate.')
				return {
					...state,
					badMsg: postAppErrorMsg + ' Please fill the confirmation field explaining why it is not ' +
						'duplicate if you believe it is not.',
					duplicate: true,
					posting: false
				};
			else return {
				...state,
				posting: false,
				badMsg: postAppErrorMsg,
			};
		case ActionTypes.RECEIVE_BAD_REQUEST_GET_APPLICATION:
			let aFormErrorMessage = '';
			try {
				aFormErrorMessage = action.payload.response.body.message
            } catch (e) {
                aFormErrorMessage = 'Failed to get the application form'
            }
			return {
				...state,
				solicitorFileReference: '',
				clientName: '',
				postCode: '',
				showForm: false,
				formData: {},
				featuredQuestions: [],
				questions: [],
				application: {},
				confirmation: '',
				extraOpponents: [],
				attachments: [],
				fetching: false,
				medicalExpertFees: [],
				getApplicationFromErrorMessage: aFormErrorMessage
			};
		case ActionTypes.UPDATE_EXTRA_OPPONENTS:
			let opponents = state.extraOpponents;
			opponents[action.payload.arrayKey] = {
				...opponents[action.payload.arrayKey],
				[action.payload.fieldKey]: action.payload.fieldValue
			};
			if (action.payload.fieldKey === 'insuredOptionId') {
				opponents[action.payload.arrayKey] = {...opponents[action.payload.arrayKey], satisfiedOptionId: ''}
			}
			return {
				...state,
				extraOpponents: opponents
			};
		case ActionTypes.UPDATE_MEDICAL_EXPERT_FEES:
			let updatedMedExpertFees = [...state.medExpertFees];
			updatedMedExpertFees[action.payload.key] = {
				...updatedMedExpertFees[action.payload.key],
				[action.payload.name]: action.payload.value
			};
			return {
				...state,
				medExpertFees: updatedMedExpertFees
			};
		case ActionTypes.REMOVE_EXTRA_OPPONENT:
			let newExtraOpp = state.extraOpponents;
			newExtraOpp.splice(action.payload, 1);
			return {
				...state,
				extraOpponents: newExtraOpp
			};
		case ActionTypes.REQUEST_PATCH_APPLICATION:
			return {
				...state,
				posting: true,
				badMsg: '',
				msg: ''
			};
		case ActionTypes.RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM:
		case ActionTypes.RECEIVE_PATCH_APPLICATION:
			if (action.payload.draft)
				return {
					...state,
					msg: "Application was saved successfully.",
					badMsg: '',
					posting: false,
					patchedApplication: action.payload,
					attachmentsForDisplay: action.payload.attachments,
					attachments: [],
					selectedApplication: action.payload,
					medicalExpertFees: action.payload.applicationMedicalExpertFees
				};
			else return {
				...state,
				posting: false,
				selectedApplication: action.payload,
				showForm: false,
				msg: msg,
				patchedApplication: {},
				duplicate: false,
				submitted: true,
				abandonedReason: defaultState.abandonedReason,
				rejectedReason: defaultState.rejectedReason,
                referredReason: defaultState.referredReason
			};
		case ActionTypes.CHANGE_APPLICATION_POLICY_SETTINGS:
			return {
				...state,
                badMsg:'',
                abandonedReason: defaultState.abandonedReason,
                rejectedReason: defaultState.rejectedReason,
                referredReason: defaultState.referredReason
			};
		case ActionTypes.RECEIVE_BAD_REQUEST_PATCH_APPLICATION:
			let errorMessage = '';
			try {
				errorMessage = action.payload.response.body.message
			}
			catch (e) {
				errorMessage = 'Failed to update the application.'
			}
			if (action.payload.status )
				return {
					...state,
					badMsg: errorMessage,
					duplicate: errorMessage.includes('duplicate'),
                    posting: false
				};
			else return {
				...state,
				posting: false,
				badMsg: 'Failed to update the application.',
			};
		case ActionTypes.RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES:
			return {
				...state,
				solicitorGroupWorkSources: action.payload
			};
			
		case '@@router/LOCATION_CHANGE':
			if (action.payload.location.pathname === '/application-and-policies/application-policy')
				return {
					...defaultState,
					selectedApplication: state.selectedApplication,
					fetchingSelectedApp: state.fetchingSelectedApp
				};
			else return {
				...defaultState,
			};
		case ActionTypes.LOGOUT:
			return {
				...defaultState
			};
		default:
			return state
	}
}